import { PaginationState } from '@tanstack/react-table';
import { PerformancePayload } from '../models/performance.model';

export const isFetchFromBackend = (reportData: PerformancePayload | null, state: PaginationState) =>
	reportData?.getTotalRows &&
	reportData?.getData() &&
	reportData?.getTotalRows() > reportData?.getData()?.length &&
	state.pageIndex * state.pageSize >= reportData?.getData()?.length &&
	reportData?.getData()?.length !== 0;
